import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { EEventsTypes } from 'interfaces/events';
import { useEventsConfigs } from 'newelements/Events/__partials/ConfigsProvider';
import 'newelements/Events/__partials/GameUsa/index.less';
import { MatchCardInlineUSASkeleton } from 'components/Shared/MatchCardInlineUSA/__partials/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import {
  getSelectedEventsType,
  getSelectedSport
} from 'store/selectors/events';

type TGameUsaSkeletonProps = {
  hideMoreWages?: boolean;
};

export const GameUsaSkeleton = ({
  hideMoreWages
}: TGameUsaSkeletonProps): ReactElement => {
  const configs = useEventsConfigs();

  const selectedEventsType = useSelector(getSelectedEventsType)[
    configs?.moduleId || ''
  ] as EEventsTypes;

  const selectedSport =
    useSelector(getSelectedSport)[configs?.moduleId || '']?.[
      selectedEventsType
    ];

  return (
    <div>
      <div className="events-game-usa__header">
        <Skeleton.Button
          className="events-game-usa__header--logo-skeleton"
          active
        />
        <Skeleton.Button
          className="events-game-usa__header--title-skeleton"
          active
        />
      </div>

      <MatchCardInlineUSASkeleton
        hideMoreWages={hideMoreWages}
        sportAlias={selectedSport?.alias}
      />
    </div>
  );
};
